import { Modal } from "react-bootstrap";
import HelpMan from "../../assets/helpman.png";
import Helpmanbase from "../../assets/helpmanbase.png";
import Tutorialicon from "../../assets/tutorialicon.png";
import SuggestionIcon from "../../assets/black/suggestion.png";
import WebIcon from "../../assets/black/web.png";
import { useNavigate } from "react-router";
import './help.css'

const HelpModal = ({
  isOpen,
  onClose,
  opensuggesstion
}) => {
  const navigate = useNavigate();
  return (
    <Modal
      className="helpmodal1"
      style={{ border: "none", backdropFilter:"blur(4px)" }}
      centered
      id="helpmodal"
      animation={true}
      show={isOpen}
      onHide={onClose}
      backdrop={true}
    >
      <Modal.Body style={{border:"none"}} onClick={onClose}>
        <div className="Mainhelpbox">
          <div className="helpdescdisplay_box">
            <div className="askText">
              <span>How may I help you ?</span>
            </div>
            <div className="detailsBox">
              <div className="image">
                <img src={HelpMan} alt="HelpMan" />
                <img src={Helpmanbase} alt="HelpMan Base" />
              </div>
              <div className="tilesmain">
                <div
                  className="box"
                  onClick={() => {
                
                   navigate("/tutorials");
                  }}
                >
                  <div className="icons">
                    <img src={Tutorialicon} alt="Tutorial Icon" />
                  </div>
                  <div className="text">
                    <span>View Tutorials</span>
                  </div>
                </div>

                <div className="box" onClick={opensuggesstion}>
                  <div className="icons">
                    <img
                      src={SuggestionIcon}
                      alt="Suggestion Icon"
                      style={{
                        filter:
                          "invert(48%) sepia(100%) saturate(1000%) hue-rotate(-50deg)",
                      }}
                    />
                  </div>
                  <div className="text">
                    <span>Report Bug / Suggestion</span>
                  </div>
                </div>

                <a
                  href="https://www.trackhrapp.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none" }}
                  onClick={onClose}
                >
                  <div className="box">
                    <div className="icons">
                      <img src={WebIcon} alt="Web Icon" />
                    </div>
                    <div className="text" style={{ color: "#000" }}>
                      <span>Visit Website</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default HelpModal;